export const PROVIDER_EVENTS = {
    INITIALIZED: "initialized",
    ERRORED: "errored",
};
//# sourceMappingURL=IProvider.js.map